<template>
  <div>
    <div v-if="isLoading">
        <CanPayLoader/>
    </div>
    <div class="my-gift-cards" style="display:block!important;">

    <!-- Action Buttons Container -->
    <div class="action-buttons-container gift-card-padding-adjustment">
      <!-- Purchase Gift Card Button -->
      <div class="purchase-button-container gift-cards-pruchase-button">
        <button
          class="purchase-gift-card-btn"
          @click="navigateToPurchase"
        >
          <div class="purchase-btn-content">
            <svg class="purchase-btn-icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <rect x="1" y="4" width="22" height="16" rx="2" ry="2"/>
              <line x1="1" y1="10" x2="23" y2="10"/>
              <path d="M12 14h.01"/>
              <path d="M16 14h.01"/>
              <path d="M8 14h.01"/>
            </svg>
            <button class="purchase-btn-text" style="background-color:#000000;border:none;color:#ffffff">Purchase Gift Card</button>
            <svg class="purchase-btn-arrow" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M9 18l6-6-6-6"/>
            </svg>
          </div>
        </button>
      </div>

      <!-- Redeem Gift Card Button -->
      <div class="redeem-button-container gift-cards-pruchase-button">
        <button
          class="redeem-gift-card-btn"
          @click="showRedeemModal"
        >
          <div class="redeem-btn-content">
            <svg class="redeem-btn-icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 56 50" fill="none">
              <path d="M48.1792 10.455H44.2467C44.7427 9.46864 45.0227 8.38778 45.0227 7.2986C45.0227 3.8475 42.4976 0.354492 37.6742 0.354492C32.7054 0.354492 29.6772 3.99916 27.9781 7.19625C26.2791 3.99916 23.2509 0.354492 18.282 0.354492C13.4586 0.354492 10.9335 3.8475 10.9335 7.2986C10.9335 8.38778 11.2136 9.46864 11.7095 10.455H7.77711C3.9475 10.455 0.833008 13.5695 0.833008 17.3991V42.6504C0.833008 46.48 3.9475 49.5945 7.77711 49.5945H48.1792C52.0088 49.5945 55.1233 46.48 55.1233 42.6504V17.3991C55.1233 13.5695 52.0088 10.455 48.1792 10.455ZM37.6742 4.14218C40.3029 4.14218 41.2351 5.84245 41.2351 7.2986C41.2351 8.75474 40.3029 10.455 37.6742 10.455H30.6224C31.6875 7.89334 33.8885 4.14218 37.6742 4.14218ZM18.282 4.14218C22.0435 4.14218 24.2516 7.89243 25.3255 10.455H18.282C15.6533 10.455 14.7212 8.75474 14.7212 7.2986C14.7212 5.84245 15.6533 4.14218 18.282 4.14218ZM51.3355 42.6504C51.3355 44.3913 49.9201 45.8068 48.1791 45.8068H7.77711C6.03616 45.8068 4.6207 44.3913 4.6207 42.6504V39.494H51.3356L51.3355 42.6504ZM51.3355 35.7063H4.6207V17.3991C4.6207 15.6582 6.03616 14.2427 7.77711 14.2427H24.191L18.8887 21.3126C18.2598 22.1497 18.43 23.3371 19.2659 23.9647C20.1044 24.5923 21.2929 24.4184 21.9168 23.5862L27.9781 15.5052L34.0394 23.5862C34.4093 24.0818 34.9789 24.3432 35.556 24.3432C35.9505 24.3432 36.35 24.2199 36.6903 23.9647C37.5262 23.3371 37.6964 22.1497 37.0676 21.3126L31.7652 14.2427H48.1791C49.9201 14.2427 51.3355 15.6582 51.3355 17.3991V35.7063Z" fill="white"/>
            </svg>
            <span class="redeem-btn-text">I have a Gift Card Code to Load</span>
            <svg class="redeem-btn-arrow" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M9 18l6-6-6-6"/>
            </svg>
          </div>
        </button>
      </div>
    </div>

    <!-- Gift Cards List -->
     <div>
    <div class="gift-cards-list" :class="{ 'transitioning': isTransitioning }">
      <transition-group name="card-list" tag="div" class="card-list-container">
        <div
          v-for="card in filteredCards"
          :key="card.id"
          :class="['gift-card-item', card.type === 'vendor' ? 'vendor-gift-card-style' : '']"
        >
        <!-- Card Top Content -->
        <div class="card-top-content">
          <!-- Card Icon or Logo -->
          <div class="card-icon" :class="{ 'has-logo': card.logo_url }">
            <div v-if="card.logo_url" class="logo-container">
              <img :src="card.logo_url" :alt="card.merchant_retailer || 'Store Logo'" class="giftcard-store-logo" />
            </div>
            <div v-else class="icon-circle">
              <svg xmlns="http://www.w3.org/2000/svg" width="56" height="50" viewBox="0 0 56 50" fill="none">
<path d="M48.1792 10.455H44.2467C44.7427 9.46864 45.0227 8.38778 45.0227 7.2986C45.0227 3.8475 42.4976 0.354492 37.6742 0.354492C32.7054 0.354492 29.6772 3.99916 27.9781 7.19625C26.2791 3.99916 23.2509 0.354492 18.282 0.354492C13.4586 0.354492 10.9335 3.8475 10.9335 7.2986C10.9335 8.38778 11.2136 9.46864 11.7095 10.455H7.77711C3.9475 10.455 0.833008 13.5695 0.833008 17.3991V42.6504C0.833008 46.48 3.9475 49.5945 7.77711 49.5945H48.1792C52.0088 49.5945 55.1233 46.48 55.1233 42.6504V17.3991C55.1233 13.5695 52.0088 10.455 48.1792 10.455ZM37.6742 4.14218C40.3029 4.14218 41.2351 5.84245 41.2351 7.2986C41.2351 8.75474 40.3029 10.455 37.6742 10.455H30.6224C31.6875 7.89334 33.8885 4.14218 37.6742 4.14218ZM18.282 4.14218C22.0435 4.14218 24.2516 7.89243 25.3255 10.455H18.282C15.6533 10.455 14.7212 8.75474 14.7212 7.2986C14.7212 5.84245 15.6533 4.14218 18.282 4.14218ZM51.3355 42.6504C51.3355 44.3913 49.9201 45.8068 48.1791 45.8068H7.77711C6.03616 45.8068 4.6207 44.3913 4.6207 42.6504V39.494H51.3356L51.3355 42.6504ZM51.3355 35.7063H4.6207V17.3991C4.6207 15.6582 6.03616 14.2427 7.77711 14.2427H24.191L18.8887 21.3126C18.2598 22.1497 18.43 23.3371 19.2659 23.9647C20.1044 24.5923 21.2929 24.4184 21.9168 23.5862L27.9781 15.5052L34.0394 23.5862C34.4093 24.0818 34.9789 24.3432 35.556 24.3432C35.9505 24.3432 36.35 24.2199 36.6903 23.9647C37.5262 23.3371 37.6964 22.1497 37.0676 21.3126L31.7652 14.2427H48.1791C49.9201 14.2427 51.3355 15.6582 51.3355 17.3991V35.7063Z" fill="white"/>
</svg>
            </div>
          </div>

          <!-- Card Content -->
          <div class="card-content">
            <div class="card-header-row">
              <!-- Standard Layout (No Logo) -->
              <div class="card-info">
                <div class="giftcard-store-info-top">
                  <div class="giftcard-store-name">{{ card.merchant_retailer || 'Canpay Gift Card' }}</div>
                </div>
                <div class="card-amount">${{ parseFloat(card.amount || 0).toFixed(2) }}</div>
              </div>

              <!-- Status Badge -->
              <div class="card-status">
                <div class="status-content">
                  <span
                    class="status-badge"
                    :class="getStatusClass(card.status, card)"
                  >
                    {{ getStatusText(card.status, card) }}
                  </span>
                </div>
              </div>
            </div>
            
            <!-- Card Number (Bottom Right - Less Prominent when Logo Present) -->
            <div class="card-number-footer">
              <span class="card-number-label">Card #:</span>
              <span class="card-number-value">{{ card.gift_card_number || card.card_number || 'N/A' }}</span>
            </div>
          </div>
        </div>

        <!-- Card Footer - Full Width -->
        <div class="card-footer" style="background-color:#ffffff!important;padding:14px 0px 0px 0px!important">
          <div class="card-type">
            <span v-html="formatCardType(card.is_generic || 'Gift Card')"></span>
          </div>
          <div class="purchase-date">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 42 42" fill="none">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M12.633 0C13.7652 0 14.683 0.940212 14.683 2.1H31.083C36.7439 2.1 41.333 6.80102 41.333 12.6V31.5C41.333 37.2989 36.7439 42 31.083 42H10.583C4.9221 42 0.333008 37.2989 0.333008 31.5V12.6C0.333008 6.80102 4.9221 2.1 10.583 2.1C10.583 0.940212 11.5008 0 12.633 0ZM10.583 6.3C7.18647 6.3 4.43301 9.12061 4.43301 12.6V31.5C4.43301 34.9795 7.18647 37.8 10.583 37.8H31.083C34.4797 37.8 37.233 34.9795 37.233 31.5V12.6C37.233 9.12061 34.4797 6.3 31.083 6.3H14.683V8.4C14.683 9.55979 13.7652 10.5 12.633 10.5C11.5008 10.5 10.583 9.55979 10.583 8.4V6.3Z" fill="black"/>
              <path fill-rule="evenodd" clip-rule="evenodd" d="M29.033 0C30.1652 0 31.083 0.940212 31.083 2.1V8.4C31.083 9.55979 30.1652 10.5 29.033 10.5C27.9008 10.5 26.983 9.55979 26.983 8.4V2.1C26.983 0.940212 27.9008 0 29.033 0Z" fill="black"/>
              <path fill-rule="evenodd" clip-rule="evenodd" d="M28.385 17.3681C29.2109 18.1612 29.2528 19.4901 28.4785 20.3362L20.791 28.7362C20.0567 29.5388 18.8423 29.6247 18.0071 28.9334L13.3945 25.1152C12.5139 24.3863 12.3769 23.0641 13.0885 22.1619C13.8001 21.2598 15.0908 21.1195 15.9714 21.8484L19.1026 24.4404L25.4873 17.4638C26.2618 16.6176 27.5591 16.5748 28.385 17.3681Z" fill="black"/>
            </svg>
            Purchased on <b>{{ formatDate(card.purchase_date || card.purchaseDate || card.created_at) }}</b>
          </div>
        </div>

        <!-- Store Information Section -->
        <div v-if="card.merchant_retailer && card.is_received == 0 && card.to_phone== null && card.to_name == null" class="store-info-section">
          <div class="store-info-text">
            Gift card will be used at store: <b>{{ card.merchant_retailer }}</b>
          </div>
        </div>

        <!-- Sharing Details Accordion -->
        <div v-if="card.to_name && card.to_phone && !card.is_received" class="sharing-accordion">
          <div
            class="sharing-accordion-header"
            @click="toggleSharingAccordion(card.id || card.gift_card_id)"
            :class="{ 'active': expandedSharingCard === (card.id || card.gift_card_id) }"
          >
            <span class="sharing-accordion-title">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8"/>
                <polyline points="16,6 12,2 8,6"/>
                <line x1="12" y1="2" x2="12" y2="15"/>
              </svg>
              Sent to {{card.to_name.split(' ')[0]}}
            </span>
            <span
              class="sharing-accordion-arrow"
              :class="{ 'rotated': expandedSharingCard === (card.id || card.gift_card_id) }"
            >
              &#9660;
            </span>
          </div>
          <div
            v-if="expandedSharingCard === (card.id || card.gift_card_id)"
            class="sharing-accordion-content"
          >
            <div class="sharing-details">
              <div class="sharing-detail-row" v-if="card.to_name">
                <span class="sharing-label">Recipient Name:</span>
                <span class="sharing-value">{{ card.to_name }}</span>
              </div>
              <div class="sharing-detail-row" v-if="card.to_phone">
                <span class="sharing-label">Phone Number:</span>
                <span class="sharing-value">{{ formatPhoneNumber(card.to_phone) }}</span>
              </div>
              <div class="sharing-detail-row" v-if="card.to_email">
                <span class="sharing-label">Email:</span>
                <span class="sharing-value">{{ card.to_email }}</span>
              </div>
              <div class="sharing-detail-row" v-if="card.merchant_retailer">
                <span class="sharing-label">Merchant/Retailer:</span>
                <span class="sharing-value">{{ card.merchant_retailer }}</span>
              </div>
              <div class="sharing-detail-row" v-if="card.message">
                <span class="sharing-label">Message:</span>
                <span class="sharing-value">{{ card.message }}</span>
              </div>
              <div class="sharing-detail-row" v-if="card.is_preferred_date==1 && card.scheduled_sharing_date && card.status=='Pending'">
                <span class="sharing-label">Set to deliver on:</span>
                <span class="sharing-value">{{ formatDate(card.scheduled_sharing_date) }}</span>
              </div>
              <div class="sharing-detail-row" v-if="card.scheduled_sharing_date && card.status=='Success'">
                <span class="sharing-label">Delivered on:</span>
                <span class="sharing-value">{{ formatDate(card.scheduled_sharing_date) }}</span>
              </div>
              <div class="sharing-detail-row" v-if="card.is_preferred_date==0 && card.scheduled_sharing_date && card.status=='Pending'">
                <span class="sharing-label text-center" style="word-break:break-all; flex-shrink: 1 !important;"><b>Transaction wil get clear in next 4-5 banking days.</b></span>
              </div>
            </div>
          </div>
        </div>

         <!-- Delivery Date Information (Independent Section) -->
        <div v-else-if="!card.is_received">
          <!-- Show delivery date if scheduled_sharing_date exists -->
          <div v-if="card.scheduled_sharing_date" class="delivery-info-box">
            <div v-if="card.status=='Pending'">
              <b>Set to deliver on:</b> {{ formatDate(card.scheduled_sharing_date) }}
            </div>
            <div v-if="card.status=='Success'">
              <b>Delivered on:</b> {{ formatDate(card.scheduled_sharing_date) }}
            </div>
          </div>
          <!-- Show banking message if no preferred date -->
          <div v-if="!card.scheduled_sharing_date && card.status=='Pending'" class="delivery-info-box delivery-info-centered">
            <b>Transaction will get clear in next 4-5 banking days.</b>
          </div>
        </div>
        <div v-if="card.from_user_name  && card.is_received" class="sharing-accordion">
          <div
            class="sharing-accordion-header"
            @click="toggleSharingAccordion(card.id || card.gift_card_id)"
            :class="{ 'active': expandedSharingCard === (card.id || card.gift_card_id) }"
          >
            <span class="sharing-accordion-title">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8"/>
                <polyline points="16,6 12,2 8,6"/>
                <line x1="12" y1="2" x2="12" y2="15"/>
              </svg>
              Received from {{ card.from_user_name.split(' ')[0] }}
            </span>
            <span
              class="sharing-accordion-arrow"
              :class="{ 'rotated': expandedSharingCard === (card.id || card.gift_card_id) }"
            >
              &#9660;
            </span>
          </div>
          <div
            v-if="expandedSharingCard === (card.id || card.gift_card_id)"
            class="sharing-accordion-content"
          >
            <div class="sharing-details">
              <div class="sharing-detail-row" v-if="card.to_name">
                <span class="sharing-label">Received from:</span>
                <span class="sharing-value">{{ card.from_user_name }}</span>
              </div>
              <div class="sharing-detail-row" v-if="card.merchant_retailer">
                <span class="sharing-label">Merchant/Retailer:</span>
                <span class="sharing-value">{{ card.merchant_retailer }}</span>
              </div>
              <div class="sharing-detail-row" v-if="card.message">
                <span class="sharing-label">Message:</span>
                <span class="sharing-value">{{ card.message }}</span>
              </div>
            </div>
          </div>
        </div>
        </div>
      </transition-group>

      <!-- Loading More Indicator -->
      <div v-if="isLoadingMore" class="loading-more mt-2">
        <div class="spinner-border " role="status">
        </div>
      </div>


      <!-- Empty State -->
      <div v-if="!isLoading && filteredCards.length === 0" class="empty-state">
        <div class="empty-icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
            <rect x="1" y="4" width="22" height="16" rx="2" ry="2"/>
            <line x1="1" y1="10" x2="23" y2="10"/>
          </svg>
        </div>
        <p class="empty-description">
          {{ getEmptyStateMessage() }}
        </p>
      </div>
    </div>
    </div>

    <!-- Gift Card Coming Soon Modal -->
    <gift-card-coming-soon-modal ref="GiftCardComingSoonModal"></gift-card-coming-soon-modal>

    <!-- Redeem Gift Card Modal -->
    <redeem-gift-card-modal
      ref="RedeemGiftCardModal"
      @gift-card-redeemed="onGiftCardRedeemed"
      @redemption-complete="onRedemptionComplete"
      @error="onRedemptionError"
    ></redeem-gift-card-modal>
  </div>
  </div>
</template>

<script>
import api from '@/api/giftcard.js';
import CanPayLoader from "../CustomLoader/CanPayLoader.vue";
import GiftCardComingSoonModal from "./Modal/GiftCardComingSoonModal.vue";
import RedeemGiftCardModal from "./Modal/RedeemGiftCardModal.vue";
export default {
  name: 'MyGiftCards',
  components:{
    CanPayLoader,
    GiftCardComingSoonModal,
    RedeemGiftCardModal
  },
  data() {
    return {
      currentTab: 'all',
      isTransitioning: false,
      giftCards: [],
      isLoading: false,
      isLoadingMore: false,
      pagination: {
        current_page: 1,
        per_page: 10,
        total: 0,
        total_pages: 0
      },
      hasMoreData: true,
      currentUser: null,
      expandedSharingCard: null
    }
  },
  mounted() {
    console.log("print gift card access: ",process.env.VUE_APP_GIFT_CARD_PURCHASE_DISABLED);
    console.log('🎁 Gift Card Purchase Disabled:', process.env.VUE_APP_GIFT_CARD_PURCHASE_DISABLED == 1);
      if(process.env.VUE_APP_GIFT_CARD_PURCHASE_DISABLED == "1"){
        this.showComingSoonModal();
        return;
      }
    // Get current user detail
    this.currentUser = localStorage.getItem("consumer_login_response")
      ? JSON.parse(localStorage.getItem("consumer_login_response"))
      : null;

    // Reset tab to 'all' and sync with App.vue state
    this.currentTab = 'all';
    // Emit a dedicated event to reset the tab state in App.vue
    this.$root.$emit('reset-gift-cards-tab', 'all');

    // Use the GiftCardsHeader which will show simple header for My Gift Cards page
    this.$root.$emit("changeWhiteBackground", [false, false, "GiftCardsHeader", { currentTab: this.currentTab }]);
    var element = document.getElementsByClassName("content-wrap");
    if (element[0]) {
      element[0].style.setProperty("background-color", "#179346");
    }
    // Listen for tab changes from the header with debounce
    this.$root.$on('gift-cards-tab-changed', (tab) => {
      if (this.isTransitioning) return;

      this.isTransitioning = true;
      this.currentTab = tab;

      // Reset data and fetch new data for the selected tab
      this.resetPagination();
      this.fetchGiftCards(true);

      // Reset transition flag after animation completes
      this.$nextTick(() => {
        setTimeout(() => {
          this.isTransitioning = false;
        }, 300); // Match the CSS transition duration
      });
    });

    // Set up infinite scroll
    this.setupInfiniteScroll();

    // Initial data fetch
    this.fetchGiftCards(true);
  },
  beforeDestroy() {
    // Clean up event listeners
    this.$root.$off('gift-cards-tab-changed');
    this.removeScrollListener();
  },
  activated() {
    // This is called when the component is activated (e.g., when navigating back)
    // Ensure tab state is reset to 'all'
    this.currentTab = 'all';
    this.$root.$emit('reset-gift-cards-tab', 'all');
    this.resetPagination();
    this.fetchGiftCards(true);
  },
  computed: {
    filteredCards() {
      // Filter cards based on current tab, including delivered cards logic
      if (this.currentTab === 'all') {
        return this.giftCards;
      } else if (this.currentTab === 'redeemed') {
        // Include both redeemed/success cards AND delivered cards (cards with share data)
        return this.giftCards.filter(card => {
          const statusLower = (card.status || '').toLowerCase();
          const isRedeemed = statusLower === 'redeemed' || statusLower === 'success';
          const isDelivered = this.hasSharedDetails(card);
          return isRedeemed || isDelivered;
        });
      } else if (this.currentTab === 'pending') {
        // Only pending cards, exclude delivered cards
        return this.giftCards.filter(card => {
          const statusLower = (card.status || '').toLowerCase();
          const isDelivered = this.hasSharedDetails(card);
          return statusLower === 'pending' && !isDelivered;
        });
      }
      return this.giftCards;
    },
    statusTypeForAPI() {
      // Map frontend tabs to backend status_type values
      const statusMap = {
        'all': 'all',
        'pending': 'pending',
        'redeemed': 'success'
      };
      return statusMap[this.currentTab] || 'all';
    }
  },
  methods: {
    resetPagination() {
      this.pagination = {
        current_page: 1,
        per_page: 10,
        total: 0,
        total_pages: 0
      };
      this.giftCards = [];
      this.hasMoreData = true;
    },

    async fetchGiftCards(isInitial = false) {
      if (this.isLoading || this.isLoadingMore || (!this.hasMoreData && !isInitial)) {
        return;
      }

      if (isInitial) {
        this.isLoading = true;
        this.resetPagination();
      } else {
        this.isLoadingMore = true;
      }

      try {
        const payload = {
          status_type: this.statusTypeForAPI,
          page: this.pagination.current_page,
          per_page: this.pagination.per_page
        };

        const response = await api.getGiftCardDetails(payload);

        if (response.code === 200 && response.data) {
          const { data, current_page, per_page, total, total_pages } = response.data;

          // Update pagination
          this.pagination = {
            current_page,
            per_page,
            total,
            total_pages
          };

          if (isInitial) {
            this.giftCards = data || [];
          } else {
            this.giftCards.push(...(data || []));
          }

          // Check if there's more data
          this.hasMoreData = current_page < total_pages;

          // Increment page for next request
          if (this.hasMoreData) {
            this.pagination.current_page = current_page + 1;
          }
        }
      } catch (error) {
        console.error('Error fetching gift cards:', error);
        // Handle error appropriately
      } finally {
        this.isLoading = false;
        this.isLoadingMore = false;
      }
    },
    setupInfiniteScroll() {
      const navDrawer = document.getElementById('nav-drawer');
      if (navDrawer) {
        navDrawer.addEventListener('scroll', this.handleScroll);
      }
    },

    removeScrollListener() {
      const navDrawer = document.getElementById('nav-drawer');
      if (navDrawer) {
        navDrawer.removeEventListener('scroll', this.handleScroll);
      }
    },

    handleScroll() {
      const navDrawer = document.getElementById('nav-drawer');
      if (!navDrawer) return;

      const scrollTop = navDrawer.scrollTop;
      const viewportHeight = navDrawer.clientHeight;
      const scrollHeight = navDrawer.scrollHeight;
      const distanceFromBottom = scrollHeight - (scrollTop + viewportHeight);

      // Load more data when near bottom (within 100px)
      if (distanceFromBottom < 100 && this.hasMoreData && !this.isLoadingMore && !this.isLoading) {
        this.fetchGiftCards(false);
      }
    },


    getStatusClass(status, card) {
      if (!status) return {};

      // Check if card has share data (delivered status)
      if (this.hasSharedDetails(card)) {
        return { 'status-delivered': true };
      }

      const statusLower = status.toLowerCase();
      return {
        'status-pending': statusLower === 'pending',
        'status-redeemed': statusLower === 'redeemed' || statusLower === 'success'
      };
    },

    getStatusText(status, card) {
      if (card.type === 'vendor' && status === 'Success') {
        return 'Received';
      }
      // Check if card has share data (delivered status)
      if (this.hasSharedDetails(card)) {
        return 'Delivered';
      }

      return status == 'Success' ? 'Redeemed' : status;
    },
    formatDate(dateString) {
      if (!dateString) return 'N/A';

      try {
        const date = new Date(dateString);
        if (isNaN(date.getTime())) return 'N/A';

        return date.toLocaleDateString('en-US', {
          month: 'short',
          day: 'numeric',
          year: 'numeric'
        });
      } catch (error) {
        return 'N/A';
      }
    },
    getEmptyStateMessage() {
      switch (this.currentTab) {
        case 'pending':
          return 'You don\'t have any pending gift cards at the moment.';
        case 'redeemed':
          return 'You don\'t have any redeemed gift cards yet.';
        default:
          return 'You don\'t have any gift cards yet.';
      }
    },



    navigateToPurchase() {
      if(process.env.VUE_APP_GIFT_CARD_PURCHASE_DISABLED === '1'){
        this.showComingSoonModal();
        return;
      }
      // Navigate to gift card purchase page
      this.$router.push('/giftcard-purchase');
    },

    showRedeemModal() {
      // Show the redeem gift card modal
      if (this.$refs.RedeemGiftCardModal) {
        this.$refs.RedeemGiftCardModal.showModal();
      }
    },

    onGiftCardRedeemed(data) {
      console.log('Gift card redeemed:', data);
      // You can show a success message or update UI here
    },

    onRedemptionComplete() {
      // Refresh the gift cards list after redemption
      this.fetchGiftCards(true);
    },

    onRedemptionError(message) {
      // Handle redemption error
      console.error('Redemption error:', message);
      // You can show an error toast/notification here
    },

    showComingSoonModal() {
      // Show the coming soon modal
      if (this.$refs.GiftCardComingSoonModal) {
        this.$refs.GiftCardComingSoonModal.showModal();
      }
    },

    formatCardType() {
      return `<span>CanPay <b> Gift Card </b></span>`
    },

    // Sharing accordion methods
hasSharedDetails(card) {
  const hasDetails =
    (card.to_name && card.to_name.trim() !== '') ||
    (card.to_phone && card.to_phone.trim() !== '');

  const today = new Date();
  const scheduledDate = new Date(card.scheduled_sharing_date);

  const isEligible =
    card.status === "Success" && today >= scheduledDate;

  return hasDetails && isEligible;
},

    toggleSharingAccordion(cardId) {
      this.expandedSharingCard = this.expandedSharingCard === cardId ? null : cardId;
    },

    formatPhoneNumber(phone) {
      if (!phone) return 'N/A';
      // Remove all non-digit characters
      const cleaned = phone.replace(/\D/g, '');
      // Format as (XXX) XXX-XXXX if it's a 10-digit US number
      if (cleaned.length === 10) {
        return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6)}`;
      }
      // Return original if not a standard format
      return phone;
    }
  }
}
</script>

<style lang="scss">
 /* My Gift Cards Mobile Styles */
.redeem-button-container {
  padding: 0px 16px 12px;
}
.store-info-text{
    font-size: 13px;
    text-align: left;
    background-color: #f8f9fa;
    outline: 1px solid #c7c7c7;
    border-radius: 4px;
    padding: 10px 12px;
    margin-top: 14px;
}
.delivery-info-box {
    font-size: 14px;
    text-align: left;
    background-color: #f8f9fa;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    padding: 12px 16px;
    margin-top: 12px;
    color: #333;

    b {
      color: #000;
      font-weight: 600;
    }
}

.delivery-info-centered {
    text-align: center;
}

/* Action Buttons Container */
.action-buttons-container {
  display: flex;
  flex-direction: column;
  gap: 0;
  margin-bottom: 20px;
}

.redeem-gift-card-btn {
  width: 100%;
  background: #000000;
  border: none;
  border-radius: 12px;
  padding: 16px 20px;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.redeem-gift-card-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);
  background: #1a1a1a;
}

.redeem-gift-card-btn:active {
  transform: translateY(0);
}

.redeem-btn-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.redeem-btn-icon {
  flex-shrink: 0;
  color: white;
}

.redeem-btn-text {
  flex: 1;
  text-align: left;
  font-size: 16px;
  font-weight: 600;
  color: white;
  font-family: 'Open Sans', sans-serif;
  text-align: center;
}

.redeem-btn-arrow {
  flex-shrink: 0;
  color: white;
  opacity: 0.8;
}

@media (max-width: 767px) {
  .store-info-text{
    padding: 12px 16px;
  }
  .delivery-info-box {
    padding: 8px 18px;
    font-size: 12px;
  }

  .action-buttons-container {
    gap: 0;
    margin-bottom: 16px;
  }

  .redeem-gift-card-btn {
    padding: 14px 16px;
  }

  .redeem-btn-text {
    font-size: 15px;
  }
}

.vendor-gift-card-style {
  border-left: 4px solid rgb(236, 184, 0) !important;
}
</style>
